/* ================================================================
   LegBilligt — pile i rullerraekker
   • laver en tilbage-pil ud fra den frem-pil raekken allerede har
   • viser kun en pil, nar der er noget at rulle til den vej
   • samme opforsel pa computer og mobil
   Daekker .lbbr-rw (kollektion/tilbud), .lbf-rw (forside),
   .lbo-rw (onskesedlen) og .lbf-usp .gw (forsidens tryghedsbaand).
   Ingen MutationObserver.
   ================================================================ */
(function(){
  'use strict';

  /* .lbf-usp .gw staar her og ikke som en klasse i lb-forside.liquid,
     fordi det er DENNE fil, der ejer spoergsmaalet om hvilke raekker der
     faar pile — saa er der ét sted at se efter.
     Jakob 7. september: "der er ikke en pil tilbage her, det skal der
     vaere paa mobil versionen, derudover skal de vaere vaek naar man ikke
     kan gaa laengere frem eller tilbage." Tryghedsbaandet (Fri fragt,
     1-3 hverdage, returret, Ring eller skriv) ruller vandret paa telefon,
     men dens wrapper hedder "gw" og blev derfor aldrig samlet op her:
     baandet havde kun en frem-pil, og den blev staaende, ogsaa naar man
     var rullet helt ud til den sidste. Maalt 7. september: gw havde
     hverken klassen lbrail eller en .lbrail-bak.
     Vil man tilfoeje endnu en raekke, er det listen her, der skal rettes
     — den skal pege paa det element, der har frem-pilen som direkte barn. */
  var GRUPPER = '.lbbr-rw, .lbf-rw, .lbo-rw, .lbf-usp .gw';

  function rulleFelt(rw){
    for(var i = 0; i < rw.children.length; i++){
      var c = rw.children[i];
      if(c.tagName !== 'BUTTON') return c;
    }
    return null;
  }

  function saet(rw){
    if(rw.dataset.lbrail) return;
    var rail = rulleFelt(rw);
    var frem = rw.querySelector(':scope > button');
    if(!rail || !frem) return;
    rw.dataset.lbrail = '1';

    /* tilbage-pilen er en kopi af frem-pilen, sa den ser ens ud
       uanset hvilken raekke den sidder i */
    var bak = frem.cloneNode(true);
    bak.classList.add('lbrail-bak');
    bak.setAttribute('aria-label', 'Tilbage');
    bak.removeAttribute('data-rail');
    bak.removeAttribute('id');
    rw.appendChild(bak);

    var afstand = getComputedStyle(frem).right;
    if(afstand && afstand !== 'auto') rw.style.setProperty('--lbrail-h', afstand);

    /* capture + stopPropagation: ellers kan raekkens egen
       delegerede klik-lytter ogsaa rulle FREM pa vores kopi */
    bak.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      rail.scrollBy({ left: -Math.round(rail.clientWidth * 0.8), behavior: 'smooth' });
    }, true);

    rw.classList.add('lbrail');

    function opdater(){
      var kanRulle = rail.scrollWidth > rail.clientWidth + 8;
      var vedStart = rail.scrollLeft <= 4;
      var vedSlut  = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      bak.classList.toggle('vis', kanRulle && !vedStart);
      frem.classList.toggle('vis', kanRulle && !vedSlut);
    }

    rail.addEventListener('scroll', opdater, { passive: true });
    rail.addEventListener('touchmove', opdater, { passive: true });
    window.addEventListener('resize', function(){ setTimeout(opdater, 60); });

    opdater();
    /* billeder og eftersendte kort aendrer bredden */
    setTimeout(opdater, 400);
    setTimeout(opdater, 1200);
    setTimeout(opdater, 2600);
    rw._lbOpdater = opdater;
  }

  function start(){
    document.querySelectorAll(GRUPPER).forEach(saet);
    /* raekker der far indhold bagefter (fx onskesedlen) */
    document.querySelectorAll('.lbrail').forEach(function(rw){
      if(rw._lbOpdater) rw._lbOpdater();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
  setTimeout(start, 1500);
  setTimeout(start, 3500);
})();
